import React from 'react';
import { JobStatusIndicator } from '../../job-indicators';

export default function JobStatusBadge({ status }) {
  // We'll reuse the JobStatusIndicator from job-indicators.js
  return <JobStatusIndicator status={status} />;
} 